<template>
	<page>
		<module title="财务设置">
			<c-form ref="form">
				<c-form title="">
					<c-form-item type="radio" label="实名功能" name="F_CONFIG_USER_AUTH_ENABLED" :options="switchOptions"></c-form-item>
					<c-form-item type="radio" v-if="systemConfig.pt_mode == '2'" label="商家订单调价承担方" name="F_CONFIG_EDIT_ORDER_UPDATE_COST" :options="switchCostOptions" word="商家对订单调价带来的利润减少是否由商家自行承担"></c-form-item>
				</c-form>
			</c-form>

			<template slot="button">
				<c-button size="m" @click="saveHandle()">保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		name: 'm_finance_config',

		data() {
			return {
				switchOptions: [{
				    name: '开启',
				    value: 'ON'
				}, {
				    name: '关闭',
				    value: 'OFF'
				}],
				switchCostOptions: [{
					name: '商家承担',
					value: 'ON'
				}, {
					name: '平台承担',
					value: 'OFF'
				}]
			}
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		
		watch: {
			
		},

		mounted() {
			this.request({
				url: '/platform_config/list',
				data: {
				    config_group: ""
				},
				loading: true,
				success: data => {
					let json = {};
					data.forEach(function (item,i){
						json[item.config_item_code] = item.config_item_value;
					});
					this.$refs.form.set(json);
				}
			});
		},

		methods: {
			enabledHandle(state, data) {
				data.enabled = state;
				if (!state) {
					data.required = false;
				}
			},
			
			saveHandle() {
				this.$refs.form.submit({
					url: '/platform_config/edit',
					dataFormatter: data => {
						let arr = [];
						for (let key in data) {
							arr.push({
								config_item_code: key.toUpperCase(),
								config_item_value: data[key].toString()
							});
						}
						return {
							platform_config_list: arr
						};
					},
					success: () => {
						this.$store.dispatch('getSystemConfig');
						this.$message({
							text: '操作成功'
						});

					}
				});
			}
		}
	}
</script>
<style lang="stylus" scoped>

</style>